import createIcon from '../../createIcon';

/**
 * @component @name Weekend
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTBDMTkuOSAxMCAxOSAxMC45IDE5IDEyVjE1SDVWMTJDNSAxMC45IDQuMTEgMTAgMyAxMEMxLjg5IDEwIDEgMTAuOSAxIDEyVjE3QzEgMTguMSAxLjkgMTkgMyAxOUgyMUMyMi4xIDE5IDIzIDE4LjEgMjMgMTdWMTJDMjMgMTAuOSAyMi4xIDEwIDIxIDEwWk0xOCA1SDZDNC45IDUgNCA1LjkgNCA3VjkuMTVDNS4xNiA5LjU2IDYgMTAuNjcgNiAxMS45NlYxNEgxOFYxMS45N0MxOCAxMC42NyAxOC44NCA5LjU3IDIwIDkuMTZWN0MyMCA1LjkgMTkuMSA1IDE4IDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Weekend = createIcon('Weekend', [
  [
    'path',
    {
      d: 'M21 10C19.9 10 19 10.9 19 12V15H5V12C5 10.9 4.11 10 3 10C1.89 10 1 10.9 1 12V17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V12C23 10.9 22.1 10 21 10ZM18 5H6C4.9 5 4 5.9 4 7V9.15C5.16 9.56 6 10.67 6 11.96V14H18V11.97C18 10.67 18.84 9.57 20 9.16V7C20 5.9 19.1 5 18 5Z',
      key: '1ppj1l',
    },
  ],
]);

export default Weekend;
